import React from 'react';
import { Modal } from 'react-bootstrap';

const SuccessModal = ({ show, onClose, reference }) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      {/* <Modal.Header closeButton>
        <Modal.Title>Demande soumise avec succès</Modal.Title>
      </Modal.Header> */}
      <Modal.Body>
        <div className="text-center">
          <img className="text-success" width={'100px'} src="/assets/images/check (1).png" alt="success" />
          <h4 className="mt-3">Votre demande n° référence <span className='text-secondary'>"{reference}"</span> a été soumise, elle sera traitée dans les plus brefs délais.</h4>
          <p>Conservez ce numéro de référence pour vos échanges avec notre équipe.</p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={onClose}>
          OK
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default SuccessModal;